import {
  collection,
  doc,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  deleteField,
  query,
  orderBy,
  type UpdateData,
} from 'firebase/firestore'
import { db, COLLECTIONS } from '@/lib/firebase'
import type { Category } from '@/types'

const col = collection(db, COLLECTIONS.categories)

function mapCategory(id: string, data: Record<string, unknown>): Category {
  return {
    id,
    name: (data.name as string) || '',
    image: (data.image as string) || undefined,
    order: Number(data.order) || 0,
    allowCustomization: data.allowCustomization === true,
    createdAt: (data.createdAt as string) || new Date().toISOString(),
    updatedAt: (data.updatedAt as string) || new Date().toISOString(),
  }
}

export async function fetchCategories(): Promise<Category[]> {
  const q = query(col, orderBy('order', 'asc'))
  const snap = await getDocs(q)
  return snap.docs.map((d) => mapCategory(d.id, d.data()))
}

export async function createCategory(
  data: Omit<Category, 'id' | 'createdAt' | 'updatedAt'>
): Promise<string> {
  const now = new Date().toISOString()
  const { image, ...rest } = data
  const ref = await addDoc(col, {
    ...rest,
    ...(image ? { image } : {}),
    createdAt: now,
    updatedAt: now,
  })
  return ref.id
}

export async function updateCategory(
  id: string,
  data: Partial<Omit<Category, 'id' | 'createdAt'>>
): Promise<void> {
  const { id: _, createdAt, image, ...rest } = data as Partial<Category>
  const payload: UpdateData<Record<string, unknown>> = {
    ...rest,
    updatedAt: new Date().toISOString(),
  }
  if (image === '') {
    payload.image = deleteField()
  } else if (image) {
    payload.image = image
  }
  await updateDoc(doc(db, COLLECTIONS.categories, id), payload)
}

export async function deleteCategory(id: string): Promise<void> {
  await deleteDoc(doc(db, COLLECTIONS.categories, id))
}
